<template>
  <multiselect
    @input="sendMembers"
    :value="value"
    :options="options"
    :multiple="true"
    :placeholder="$t('selectMembers.PLACEHOLDER')"
    track-by="id"
    :selectLabel="$t('selectMembers.label.SELECT')"
    :selectedLabel="$t('selectMembers.label.SELECTED')"
    :maxHeight="270"
    :deselectLabel="$t('selectMembers.label.DESELECT')">
    <template slot="selection" slot-scope="{ values, search, isOpen }">
      <span
        class="multiselect__single"
        v-if="value.length && !isOpen">
        {{ $tc('selectMembers.SELECTION', value.length) }}
      </span>
    </template>
    <template slot="noOptions">{{ $t('selectExam.NO_OPTIONS') }}</template>
    <!-- Пустой слот ниже оставлен пустым специально -->
    <template slot="tag"><span></span></template>
    <template slot="option" slot-scope="props">
      <div class="option__desc">
        <span class="option__title">{{ fullName(props.option) }} {{ props.option.email }}</span>
      </div>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { fullName } from '@/utils/utils.format'

export default {
  name: 'SelectMembers',
  props: {
    options: [Array],
    value: {
      type: Array,
      default: Array
    }
  },
  components: {
    Multiselect
  },
  methods: {
    fullName,
    sendMembers (options) {
      this.$emit('input', options)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

@import "~@/styles/base.scss";

.multiselect {
  margin: $input-margin;
}

</style>
